import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import '@/assets/toolsModal.scss';
import sentGAEvent from '../../views/account/ga';
import { useTranslation } from 'react-i18next';
import '../../assets/leaveModal.scss';
import action from '../../views/account/redux/action';
import { requestPurchaseUrl } from '@/views/account/api/apiHistory';
import myUtil from '../../utils/index';
import cartUrl from '@/views/account/utils/cartUrl';
import {
  requsetGetSubscription,
  requsetGetAllSubscription,
} from '@/views/account/api/apis';
const ToolsPurchaseModal = () => {
  const { t } = useTranslation('upgradePersonal');
  const reducerData = useSelector((state) => state.account.openLeave);
  const [timeRemaining, setTimeRemaining] = useState(30 * 60);
  const [urlParam, setUrlParam] = useState('');
  const [isRunning, setIsRunning] = useState(false);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(
      action.onOpenLeaveDialog({
        open: false,
      })
    );
    requsetGetSubscription()
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          console.log('res---------------', res);
          dispatch(action.onSubscriptionChange(res.data.subscription));
        }
      })
      .catch((err) => {
        console.log(err);
      });
    requsetGetAllSubscription().then((res) => {
      console.log(res);
      if (res.code === 200) {
        console.log('allRes..............', res);
        dispatch(action.getAllSubscription(res.data.subscription));
      }
    });
  };

  useEffect(() => {
    if (location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = myUtil.getUrlParam(location.href);
      setUrlParam(urlParam);
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      setUrlParam(obj);
    }
  }, []);

  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        setTimeRemaining((prevTime) => prevTime - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning]);

  const startTimer = () => {
    setIsRunning(true);
  };

  const stopTimer = () => {
    setIsRunning(false);
    setTimeRemaining(30 * 60);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes} min ${seconds} s`;
  };

  useEffect(() => {
    if (reducerData.open) {
      startTimer();
    } else {
      stopTimer();
    }
    return () => {
      stopTimer();
    };
  }, [reducerData.open]);

  const openPurchase = () => {
    let newParam = { ...urlParam };
    newParam['track[reason]'] = '17';
    newParam['track[func]'] = '1';
    let str = `plan=discount&site=en&FromProduct=video-watermark-remove`;

    requestPurchaseUrl('product-check-out' + '?' + str).then((res) => {
      if (res.code === 200) {
        let url =
          res.data.cart_url +
          `&track[type]=${newParam['track[type]']}&track[sid]=${
            newParam['track[sid]']
          }&track[func]=${newParam['track[func]']}&track[reason]=${
            newParam['track[reason]']
          }&track[host]=${newParam['track[host]']}&track[platform]=${
            newParam['track[platform]']
          }&track[cycle]=${1}&track[ab]=${
            newParam['track[ab]']
          }&track[channel]=${newParam['track[channel]']}&track[discount]=${1}`;
        window.open(url);
      }
    });
  };
  return (
    <Modal
      centered
      width={500}
      className='toolsLeavePurchase'
      visible={reducerData.open}
      footer={null}
      maskClosable={false}
      onCancel={() => closeModal()}
    >
      <div>
        <div class='percent'>
          <span class='percentage'>78%</span>
          <span class='off'>
            {
              // userInfoStore.currentFunc == 1 ? $t('text.OFF') : $t('Maps.OFF')
              'OFF'
            }
          </span>
        </div>

        <div className='title'>{t('exclDeal')}</div>
        <div className='subTitle'>
          {t('endDeal')} : {formatTime(timeRemaining)}
        </div>

        <div className='buyNowContainer'>
          <Button
            onClick={() => openPurchase()}
            type='primary'
            className='buyNow'
          >
            {t('discountPrice')}
          </Button>
        </div>
        <div className='ratherText'>{t('rather')}</div>
      </div>
    </Modal>
  );
};

export default ToolsPurchaseModal;
